<template>
  <HPopup class="h-sell-popup"
          ref="popup"
          v-show="visible">
    <div class="h-sell-body">
      <div class="sell-header">交易所老板说道：这里寄卖商品，需要支付100金币/件/天。</div>

      <div class="sell-form h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <HArtifact :artifact="sellItemInfo"></HArtifact>
        <div class="sell-form-item sell-gold">
          <p class="ls-1">售卖单价</p>
          <div>
            <input type="text" maxlength="9" spellcheck="false" placeholder="售价"
                   :value="form.gold" @blur="handleFixGold">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">寄卖数量</p>
          <div>
            <HInputNumber :min="1" :max="sellItemInfo.amount" v-model="form.amount"></HInputNumber>
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">寄卖天数</p>
          <div>
            <input type="text" maxlength="2" spellcheck="false" placeholder="寄卖天数"
                   :value="form.dayNum" @blur="handleFixDayNum">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">寄卖花费</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="sellCost">
          </div>
        </div>

      </div>
    </div>

    <footer class="flex">
      <button v-click-sound-button
              class="h-btn normal btn-border"
              :disabled="submitDisable"
              @click="handleSubmit">
        寄卖
      </button>
      <button v-click-sound-button
              class="h-btn normal btn-border"
              @click="handleClose">
        取消
      </button>
    </footer>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import HArtifact from '@/components/h-artifact/index'
  import HInputNumber from '@/components/h-input-number/index'
  import { mapGetters } from 'vuex'
  import API from '@js/api'

  export default {
    name: 'sell-popup',

    data () {
      return {
        form: {
          gold: 0,
          amount: 1,
          dayNum: 1,
        },
        submitLoading: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
      sellItemInfo: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold'
      ]),

      sellCost () {
        return 100 * this.form.dayNum || 0
      },

      submitDisable () {
        const { gold, amount, dayNum } = this.form
        return !gold || !amount || !dayNum
      },
    },

    mounted () {
    },

    methods: {
      handleClose () {
        this.$emit('close')
      },

      handleFixGold (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.gold = Math.max(+v, 0)
        this.$forceUpdate()
      },

      handleFixAmount (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.amount = Math.max(+v, 0)
        this.$forceUpdate()
      },

      handleFixDayNum (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.dayNum = Math.max(+v, 0)
        this.$forceUpdate()
      },

      async handleSubmit () {
        try {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          if (this.gold < this.sellCost) {
            this.$message('你的金币不足')
            return
          }
          if (this.form.gold <= 0) {
            this.$message('未设置有效售价')
            return
          }
          if (this.form.amount <= 0) {
            this.$message('未设置有效数量')
            return
          }
          if (this.form.amount > this.sellItemInfo.amount) {
            this.$message('数量超过最大值')
            return
          }
          if (this.form.dayNum <= 0) {
            this.$message('未设置有效天数')
            return
          }
          if (this.form.dayNum > 99) {
            this.$message('天数超过最大值')
            return
          }

          await API.market.sell({
            id: this.sellItemInfo.id,
            ...this.form,
          })
          this.$emit('close')
          this.$emit('refresh')
          this.$message('物品已寄售')
        } catch (err) {
          this.$message(err)
        } finally {
          this.submitLoading = false
        }
      },

    },

    components: {
      HPopup,
      HArtifact,
      HInputNumber,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-sell-body
    padding 10px
    width 600px

  footer
    margin-top 30px
    justify-content space-evenly

  .sell-header
    padding 10px 0
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()

  .sell-form
    position relative
    display flex
    margin 10px 0
    padding 3px
    justify-content space-between

  .h-artifact
    flex-shrink 0

  .sell-form-item
    position relative
    display flex
    flex-direction column
    justify-content space-evenly
    width 120px
    flex-shrink 0
    padding 2px 5px
    font-size 12px
    text-align center
    goldText1()
    input
      height 24px
      border 1px solid rgba(255, 255, 255, 0.25)
      line-height 22px
      font-size 12px
      letter-spacing 1px
      border-radius 2px
      background-color rgba(0, 0, 0, 0.25)

</style>
